/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  CheckRegisteredUser,
  SendMobileOtp,
  UpdateMobileNumber,
  VerifyMobileOtp,
  VerifyMobileUpdateOtp,
} from "../../../Store/Actions/userActionCreator";
import { Button, CustomTextField, CountryCodeSelect } from "../../UI";
import Modal from "../Modal";
import { useFormik } from "formik";
import * as yup from "yup";
import { withRouter } from "react-router-dom";
import OtpInput from "react-otp-input";
import { makeStyles } from "@mui/styles";
import { MobileOTP } from "../../../Assets/svg";
import { showMessage } from "../../../Utils/helper";
import {
  DEFAULT_COUNTRY_CODE,
  getMobileError,
  getMobileLabel,
  getOtpChannel,
  isValidMobile,
} from "../../../Utils/mobile";

const useStyles = makeStyles((theme) => ({
  topBar: {
    display: "flex",
    flex: "1 1 15%",
    // border: '1px solid black',
  },

  otpInputStyle: {
    width: "56px !important",
    height: "60px !important",
    borderRadius: "12px",
    border: "2px solid #d5dbe6",
    background: "#f8f9fe",
    color: "#1e1b4b",
    fontSize: "26px",
    fontWeight: 700,
    outline: "none",
    margin: "0 6px",
    "&:focus": {
      borderColor: "#4f46e5",
      background: "#fff",
      boxShadow: "0 0 0 4px rgba(79,70,229,.15)",
    },
    "@media (max-width: 420px)": {
      width: "46px !important",
      height: "52px !important",
      margin: "0 3px",
    },
  },
  error: {
    border: "2px solid #ef4444 !important",
  },
}));

const validationSchema = yup.object({
  key: yup
    .string("Invalid contact no.")
    .trim()
    .test("mobileFormat", function (value) {
      const error = getMobileError(this.parent.countryCode, value);
      return error ? this.createError({ message: error }) : true;
    }),
  otp: yup
    .string()
    .length(4, "OTP should be 4 digit")
    .required("OTP cannot be empty"),
});

function MobileOtpVerificationModal({
  data,
  open,
  onClose,
  next,
  blockClose = true,
  dispatchSendMobileOtp,
  dispatchVerifyMobileOtp,
  dispatchUpdateMobileNumber,
  dispatchCheckRegisteredUser,
  dispatchVerifyMobileUpdateOtp,
  ...props
}) {
  const classes = useStyles();
  const [isOpen, toggleModal] = useState(open);
  const [loading, toggleLoading] = useState(false);
  const [contactNumber, setContactNumber] = useState(data?.mobileNumber ?? "");
  const [contactCountryCode, setContactCountryCode] = useState(
    data?.countryCode ?? DEFAULT_COUNTRY_CODE
  );
  const [countDown, setCountDown] = useState(60);

  const [hasError, setHasError] = useState(false);
  let interval = null;

  const handleClose = () => {
    // Setting form data to null before closing

    toggleModal(!isOpen);
    onClose && onClose();
  };

  const otpHandler = (otp) => {
    formik.setFieldValue("otp", otp, true);
    if (otp.length !== 4) {
      setHasError(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      otp: "",
      key: data?.mobileNumber ?? null,
      countryCode: data?.countryCode ?? DEFAULT_COUNTRY_CODE,
    },
    validationSchema: validationSchema,
    onSubmit: async (values, err) => {
      const payload = {
        ...values,
      };
      toggleLoading(true);
      if (!!data?.validateNewOTP) {
        dispatchVerifyMobileUpdateOtp(
          {
            ...payload,
          },
          (resp) => {
            if (!!resp?.status) {
              toggleLoading(false);
              showMessage(resp?.result, "success");
              !!next &&
                next({
                  ...values,
                });
            } else {
              toggleLoading(false);
              showMessage(resp?.result, "error");
            }
          },
          (err) => {
            toggleLoading(false);
            showMessage(err, "error");
          }
        );
      } else
        dispatchVerifyMobileOtp(
          payload,
          (resp) => {
            if (!!resp?.status) {
              toggleLoading(false);
              showMessage(resp?.result, "success");
              props?.history?.push("/register/basic");
            } else {
              toggleLoading(false);
              showMessage(resp?.result, "error");
            }
          },
          (err) => {
            toggleLoading(false);
            showMessage(err, "error");
          }
        );
    },
  });

  const isContactChanged =
    formik.values.key !== contactNumber ||
    formik.values.countryCode !== contactCountryCode;

  const SendOTP = (cb) => {
    toggleLoading(true);
    dispatchSendMobileOtp(
      {},
      (resp) => {
        if (resp.status) {
          showMessage(resp?.result, "success");
          !!cb && cb();
        } else {
          showMessage(resp?.result, "error");
        }
        toggleLoading(false);
      },
      (err) => {
        toggleLoading(false);
        showMessage(err, "error");
      }
    );
  };

  const resetOtpTimer = () => {
    setCountDown(60);
    interval = setInterval(() => {
      setCountDown((lastTimerCount) => {
        if (lastTimerCount <= 1) {
          clearInterval(interval);
        }
        return lastTimerCount - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    formik.setFieldValue("key", data?.mobileNumber ?? null);
    if (!!data?.mobileNumber && !data?.validateNewOTP) {
      SendOTP(() => {
        resetOtpTimer();
      });
    } else {
      resetOtpTimer();
    }
  }, []);

  const actions = [];
  return (
    <Modal
      onClose={handleClose}
      open={isOpen}
      blockClose={blockClose}
      title={
        <Typography
          variant="h5"
          style={{
            textAlign: "center",
            marginTop: "8px",
            // marginBottom: "24px",
            // fontFamily: "Montserrat",
            fontWeight: "bold",
            color: "#1e1b4b",
          }}
        >
          Mobile Verification
        </Typography>
      }
      isCustomTitle={true}
      actions={actions}
      loading={loading}
      isForm={true}
      onSubmit={formik.handleSubmit}
      maxWidth="sm"
    >
      <Box
        style={{
          // padding: "0 15px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <MobileOTP style={{ width: "auto", height: "110px", maxWidth: "100%" }} />
        <Typography
          variant="body1"
          color={"#5b6275"}
          marginTop={"20px"}
          marginBottom={"20px"}
          textAlign="center"
        >
          {`Please enter the  OTP sent via ${getOtpChannel(
            contactCountryCode
          )} to your registered  Mobile +${contactCountryCode} ${contactNumber} to continue setting up your account`}
        </Typography>
        {!data?.validateNewOTP && (
          <Box
            style={{
              display: "flex",
              gap: "8px",
              width: "100%",
              marginBottom: "16px",
            }}
          >
          <CountryCodeSelect
            value={formik.values.countryCode}
            onChange={formik.handleChange}
          />
          <CustomTextField
            label={getMobileLabel(formik.values.countryCode)}
            id="key"
            name="key"
            value={formik.values.key}
            onChange={formik.handleChange}
            onBlur={(e) => {
              if (isValidMobile(formik.values.countryCode, formik.values.key))
                dispatchCheckRegisteredUser(
                  {
                    userId: formik.values.key,
                  },
                  (resp) => {
                    if (!resp?.status) {
                      formik.setFieldError(
                        "key",
                        "Mobile Number is already registered"
                      );
                    }
                  },
                  (err) => {
                    showMessage(err ?? "Server Error", "error");
                  }
                );
              formik.handleBlur(e);
            }}
            error={formik.touched.key ? Boolean(formik.errors.key) : false}
            helperText={formik.touched.key && formik.errors.key}
            isRequired={true}
            style={{ flex: 1 }}
            // variant={"standard"}
          />
          </Box>
        )}
        <Typography
          variant="body1"
          color={"#5b6275"}
          marginBottom={"5px"}
          textAlign="center"
        >
          Enter the 4 digit OTP
        </Typography>
        {
          <OtpInput
            inputStyle={classes.otpInputStyle}
            numInputs={4}
            hasErrored={hasError}
            errorStyle={classes.error}
            onChange={otpHandler}
            containerStyle={{ justifyContent: "center" }}
            isInputNum={true}
            shouldAutoFocus
            value={formik.values.otp}
            disabledStyle={{ borderColor: "#898686" }}
            isDisabled={isContactChanged}
          />
        }

        {isContactChanged &&
        isValidMobile(formik.values.countryCode, formik.values.key) ? (
          <Button
            variant="contained"
            color="primary"
            style={{ width: "50%", marginTop: "70px", fontWeight: "bold" }}
            type="button"
            onClick={(e) => {
              toggleLoading(true);
              dispatchUpdateMobileNumber(
                {
                  mobileNumber: formik.values.key,
                  countryCode: formik.values.countryCode,
                },
                (resp) => {
                  if (resp.status) {
                    showMessage(resp?.result, "success");
                    SendOTP(() => {
                      resetOtpTimer();
                      setContactNumber(formik.values.key);
                      setContactCountryCode(formik.values.countryCode);
                    });
                  } else {
                    showMessage(resp?.result, "error");
                  }
                  toggleLoading(false);
                },
                (err) => {
                  showMessage(err, "error");
                  toggleLoading(false);
                }
              );
            }}
          >
            Update & Resend OTP
          </Button>
        ) : (
          <>
            <Typography
              variant="caption"
              color={"#898686"}
              marginTop={"1px"}
              marginBottom={"32px"}
            >
              {countDown !== 0
                ? `Resent OTP in ${countDown} seconds`
                : "Havent received yet? "}
              {countDown === 0 && (
                <Typography
                  variant="caption"
                  color={"#4f46e5"}
                  marginTop={"1px"}
                  marginBottom={"50px"}
                  style={{ cursor: countDown === 0 ? "pointer" : "" }}
                  onClick={(e) => {
                    if (countDown === 0)
                      SendOTP(() => {
                        clearInterval(interval);
                        resetOtpTimer();
                      });
                  }}
                >
                  Resend OTP
                </Typography>
              )}
            </Typography>
            <Box
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
              }}
            >

              {!!data?.validateNewOTP && (
                <Button
                  style={{
                    width: "40%",
                    fontWeight: 700,
                  }}
                  variant="outlined"
                  type="button"
                  onClick={(e) => {
                    handleClose();
                  }}
                >
                  Cancel
                </Button>
              )}
              <Button
                variant="contained"
                color="primary"
                style={{ width: "40%", fontWeight: "bold", marginLeft: "1em", }}
                type="submit"
                disabled={isContactChanged}
              >
                VERIFY
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchSendMobileOtp: (payload, onSuccess, onError) =>
    dispatch(SendMobileOtp(payload, onSuccess, onError)),
  dispatchVerifyMobileOtp: (payload, onSuccess, onError) =>
    dispatch(VerifyMobileOtp(payload, onSuccess, onError)),
  dispatchUpdateMobileNumber: (payload, onSuccess, onError) =>
    dispatch(UpdateMobileNumber(payload, onSuccess, onError)),
  dispatchCheckRegisteredUser: (payload, onSuccess, onError) =>
    dispatch(CheckRegisteredUser(payload, onSuccess, onError)),
  dispatchVerifyMobileUpdateOtp: (payload, onSuccess, onError) =>
    dispatch(VerifyMobileUpdateOtp(payload, onSuccess, onError)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MobileOtpVerificationModal));
